import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-between mt-4" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]




export default /*#__PURE__*/_defineComponent({
  __name: 'LabelAndValueDiv',
  props: {
    label: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
  label: string
  value: string
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: props.label,
      class: "text-left font-semibold flex items-center pr-4"
    }, _toDisplayString(props.label), 9, _hoisted_2),
    _createElementVNode("p", {
      id: props.label,
      class: "text-right"
    }, _toDisplayString(props.value), 9, _hoisted_3)
  ]))
}
}

})